// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"480":"ecef5825","481":"09271e55"}[chunkId] + ".js";
};